import { Link } from 'found';
import React from 'react';

import { Typography } from '@mui/material';

import { palette } from '../../../../../assets/styles/themes/tokens';
import getTextTruncationSx from '../../../../../utils/getTextTruncationSx';
import Tooltip from '../../../../Tooltip';
import { MuiCardBaseProps } from '../MuiCardBase';
import { colors } from '../../../../../assets/styles/themes/variables';

const MuiCardBaseLongTitle: React.FC<{
    title: MuiCardBaseProps['title'];
    itemLink: string
  }> = ({ title, itemLink }) => {
    return (
      <Link to={itemLink}>
        <Tooltip label={title} placement='top' hideWithoutOverflow={true}>
          <Typography
            variant='h5'
            data-testid='mui-card-desktop__title'
            sx={{
              ...getTextTruncationSx(2),
              color: palette.text.primary,
              transition: 'color 300ms ease-out',
              ':hover': {
                color: colors.blue500,
              },
            }}
          >
            {title}
          </Typography>
        </Tooltip>
      </Link>
    );
  };

export default MuiCardBaseLongTitle;
